<main id="main">
  <!-- ======= Breadcrumbs ======= -->
  <div class="breadcrumbs" data-aos="fade-in">
    <div class="container">
      <h2 [innerHTML]="title"></h2>
    </div>
  </div><!-- End Breadcrumbs -->
  <!-- ======= Doctors Section ======= -->
  <section id="doctors" class="doctors">
    <div class="container">

      <!-- <div class="section-title pb-0">
        <h2>Free download</h2>
        <p [innerHTML]="subtitle"></p>
      </div> -->

      <div class="row">

        <div class="col-lg-6 mt-4" *ngFor="let book of books | async">
          <div class="member d-flex align-items-start">
            <div class="border-1"><img style="width: 100px;" class="boarder-padding"
                src='{{"../assets/"+book.coverthmpath}}' alt=""></div>
            <div class="member-info">
              <h4 class="marathi-font">{{book.name}}</h4>
              <p class="marathi-font"><i class="bi bi-pen-fill"></i> {{book.author}}</p>
              <p class="marathi-font"><i class="bi bi-bank "></i> {{book.publisher}}</p>
              <p><i class="bi bi-calendar3"></i>
                Published: {{book.date | date }}
              </p>
              <p>
                <i class="bi bi-calendar-week-fill"></i>
                Uploaded: {{book.createdon | date }}
              </p>
              <br>
              <div>
                <a [href]='"../assets/"+book.bookpath' [download]="book.name+'.pdf'" class="default-button"><i class="bi bi-download"></i>
                  Download</a>
                <a (click)="readOnline(book.bookpath, book.name)" data-bs-toggle="modal"
                  data-bs-target="#readOnlineModal" class="default-button"><i class="bi bi-book"></i>
                  Read Online</a>
                <a (click)="abstract(book.bookabstract, book.name, book.footer)" data-bs-toggle="modal"
                  data-bs-target="#abstractModal" class="default-button"><i class="bi bi-book-fill"></i>
                  Abstract</a>
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>
  </section><!-- End Doctors Section -->


</main>


<!-- The Modal -->
<div class="modal" id="readOnlineModal">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title"><span class="marathi-font-lg">{{onlineReadHeader}}</span></h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <iframe id="readOnline" src="" width="100%" height="99%"
          style="overflow: none; background-color: transparent;border: none;"></iframe>
      </div>
    </div>
  </div>
</div>

<!-- The Modal -->
<div class="modal" id="abstractModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title"><span class="marathi-font-lg">{{onlineReadHeader}}</span></h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <!-- Modal body -->
      <div class="modal-body" >
          <p class="marathi-font" [innerHTML]='abstractbody'></p>
          <p *ngIf="type=='pothi'" class="marathi-font" [innerHTML]='abstractfooter'></p>
      </div>
    </div>
  </div>